import { PropsWithChildren, ReactNode } from 'react'

type Props = {
  body: ReactNode
  heading: string
  titleAction?: ReactNode
}

const PageHeader = ({ body, children, heading, titleAction }: PropsWithChildren<Props>) => {
  return (
    <div>
      <div className="space-y-2 mb-5">
        <div className="flex items-center justify-between gap-4">
          <h4 className="text-2xl font-heading font-black">{heading}</h4>
          {titleAction}
        </div>
        {typeof body === 'string' ? <PageHeaderBody>{body}</PageHeaderBody> : body}
      </div>
      {children}
    </div>
  )
}

export const PageHeaderBody = ({ children }: PropsWithChildren) => {
  return <div className="text-text-secondary text-lg max-w-prose whitespace-pre-line">{children}</div>
}

export default PageHeader
